import { IEventResultReasonData } from "common/records/EventResultReason";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_EVENT_RESULT_REASON = "@eventResultReasons/RECEIVE_EVENT_RESULT_REASON";
export const RECEIVE_EVENT_RESULT_REASONS = "@eventResultReasons/RECEIVE_EVENT_RESULT_REASONS";

export const EventResultReasonActions = {
  receiveEventResultReason: (resultReason: IEventResultReasonData) =>
    createAction(RECEIVE_EVENT_RESULT_REASON, { resultReason }),
  receiveEventResultReasons: (resultReasons: IEventResultReasonData[]) =>
    createAction(RECEIVE_EVENT_RESULT_REASONS, { resultReasons }),
};

export type EventResultReasonActions = ActionsUnion<typeof EventResultReasonActions>;
